import { LOCAL_STORAGE_KEY_JWT } from '@/api'
import LogoHorizontal from '@/assets/icons/logo-horizontal.svg?react'
import { InviteReferralButton } from '@/features/referrals/components/InviteReferralButton'
import { useFetchUserWallet } from '@/features/stake-sol/api'
import { ConnectWalletButton } from '@/features/stake-sol/components/ConnectWalletButton'
import { LanguageSwitcher } from '@/ui-kit'
import { useLocalStorage } from '@/utils/useLocalStorage'
import { Trans } from '@lingui/react/macro'
import { LAMPORTS_PER_SOL } from '@solana/web3.js'

import { clsx } from 'clsx'
import { Menu, X } from 'lucide-react'
import { Link } from 'react-router-dom'

const StakeSummary = () => {
  const { data: userWallet } = useFetchUserWallet()
  const stakeLamports = userWallet?.wallet?.stakeLamports || 0

  return (
    <>
      <div className="text-gray-90 mr-4 ml-auto flex flex-col items-end max-[600px]:hidden">
        <div className="text-body-3">
          <Trans>You have staked:</Trans>
        </div>
        <div className="text-gray-70 font-semibold">{Number((stakeLamports / LAMPORTS_PER_SOL).toFixed(2))} SOL</div>
      </div>
      <ConnectWalletButton className="mr-2 max-[600px]:hidden" />
    </>
  )
}

export const HeaderAuthorized = ({
  isMenuOpened,
  setIsMenuOpened
}: {
  isMenuOpened: boolean
  setIsMenuOpened: (value: boolean | ((value: boolean) => boolean)) => void
}) => {
  const [jwt] = useLocalStorage(LOCAL_STORAGE_KEY_JWT, '')

  return (
    <header className="bg-background max-tablet:px-4 max-mobile:px-5 sticky top-0 z-[2] flex h-[var(--header-height)] items-center justify-between border-b border-solid border-[var(--color-gray-100)] py-4 pr-6 pl-10">
      <ul
        className={clsx('max-mobile:flex -m-4 hidden cursor-pointer flex-col gap-[6px] p-4')}
        onClick={() => setIsMenuOpened((value) => !value)}
      >
        {isMenuOpened ? <X /> : <Menu />}
      </ul>
      <Link
        to="/"
        onClick={() => {
          setTimeout(() => setIsMenuOpened(false), 250)
        }}
        className="max-mobile:ml-6 cursor-pointer max-[600px]:absolute max-[600px]:left-1/2 max-[600px]:ml-0 max-[600px]:-translate-x-1/2"
      >
        <LogoHorizontal />
      </Link>
      <div className="max-mobile:gap-2 ml-auto flex items-center gap-3">
        {jwt && <StakeSummary />}
        <InviteReferralButton collapseMobile />
        <LanguageSwitcher />
      </div>
    </header>
  )
}
